// ©2024 Austin App House. All rights reserved.
import React from 'react';
import { connect } from 'react-redux';
import Loader from '../dashboard/common/Loader';

const CustomLoader = () => (
  <div className="dashboard-loader-overlay dashboard-loader-overlay--spiral" role="status" aria-live="polite" aria-label="Loading">
    <Loader size="lg" className="wurqly-spiral-loader-wrap--page" />
  </div>
);

const mapStateToProps = (state) => ({
  modalState: state.modalState.loader,
});

export default connect(mapStateToProps)(CustomLoader);
